import React from "react";

import PropTypes from "prop-types";
import styled from "styled-components";

const StyledLabel = styled.label`
  display: flex;
  flex-direction: column;
  margin: 15px 0;
  font-size: 1rem;
  font-weight: bold;
`;

const StyledInput = styled.input`
  border-width: 0 0 2px 0;
  border-color: ${({ error }) => (error ? "#ff0000" : "#000")};
  font-size: 2rem;
  outline: none;
`;

const StyledError = styled.span`
  color: #ff0000;
`;

function Input(props) {
  const {
    name,
    label,
    register,
    validate,
    errors,
    type = "text",
    defaultValue = "",
    onBlur,
    onFocus,
  } = props;

  return (
    <StyledLabel htmlFor={name}>
      {label && label}
      <StyledInput
        error={errors[name]?.message}
        id={name}
        type={type}
        {...register(name)}
        defaultValue={defaultValue}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {register && validate && errors[name] && (
        <StyledError error={errors[name]?.message}>
          {errors[name]?.message}
        </StyledError>
      )}
    </StyledLabel>
  );
}

Input.defaultProps = {
  defaultValue: "",
  errors: null,
  label: null,
  register: null,
  type: "text",
  validate: false,
  onFocus: () => {},
  onBlur: () => {},
};

Input.propTypes = {
  defaultValue: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  register: PropTypes.func,
  type: PropTypes.string,
  validate: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export default Input;
